export function getToken(){
	return sessionStorage.getItem('vue_admin_template_token') || null
}
export function getUserInfo(){
	return sessionStorage.getItem('vue_admin_template_UserInfo') || null
}